export const personTable = function () {
  return {
    index: true,
    indexLabel: "序号",
    highlightCurrentRow: true,
    maxHeight: "100%",
    column: [
      {
        label: "姓名",
        prop: "name",
        search: true,
        clearable: true
      }
    ]
  };
};
